import { useCallback, useState } from 'react';
import { Hub } from '@/api/apis/facilities';
import { useHubsSearchableList } from '@/hooks/useHubsSearchableList';

export const useHubSelection = () => {
  const [selectedHub, setSelectedHub] = useState<Hub | undefined>(undefined);
  const { list: hubSelectList, hubs } = useHubsSearchableList({ searchBy: [] });

  const onHubSelectChange = useCallback(
    (hubId?: string) => {
      const currentHub = hubs?.find((d) => d.id === hubId);
      if (currentHub) {
        setSelectedHub(currentHub);
      }
    },
    [hubs, setSelectedHub],
  );

  return { selectedHub, onHubSelectChange, hubSelectList };
};
